import { useTranslation } from 'react-i18next';
import { InputFieldTime } from 'qampo-ui-library';
import { DateField } from '../UI/base';
import styles from './ClosedDayFields.module.css';

interface ClosedDayFieldsProps {
  isFullDay: boolean;
  fromDate: string;
  toDate: string;
  startTime: string;
  endTime: string;
  dateError?: string;
  toDateError?: string;
  timeError?: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  onStartTimeChange: (time: string) => void;
  onEndTimeChange: (time: string) => void;
}

export const ClosedDayFields = ({
  isFullDay,
  fromDate,
  toDate,
  startTime,
  endTime,
  dateError,
  toDateError,
  timeError,
  onFromDateChange,
  onToDateChange,
  onStartTimeChange,
  onEndTimeChange
}: ClosedDayFieldsProps) => {
  const { t } = useTranslation();

  if (isFullDay) {
    return (
      <div className={styles.dateRow}>
        <DateField
          label={t('closed-day-from-date-label')}
          required
          value={fromDate}
          onChange={onFromDateChange}
          error={Boolean(dateError)}
          helperText={dateError}
        />
        <DateField
          label={t('closed-day-to-date-label')}
          value={toDate}
          onChange={onToDateChange}
          error={Boolean(toDateError)}
          helperText={toDateError ?? t('closed-day-to-date-hint')}
        />
      </div>
    );
  }

  return (
    <>
      <div className={styles.dateTimeRow}>
        <DateField
          label={t('booking-date-label')}
          required
          value={fromDate}
          onChange={onFromDateChange}
          error={Boolean(dateError)}
          helperText={dateError}
        />
        <div className={styles.timeFields}>
          <InputFieldTime
            label={t('booking-start-time-label')}
            width={120}
            value={startTime}
            error={Boolean(timeError)}
            onChange={(e) => onStartTimeChange(e.target.value)}
          />
          <span className={styles.timeSeparator}>&ndash;</span>
          <InputFieldTime
            label={t('booking-end-time-label')}
            width={120}
            value={endTime}
            error={Boolean(timeError)}
            onChange={(e) => onEndTimeChange(e.target.value)}
          />
        </div>
      </div>
      {timeError && <span className={styles.timeError}>{timeError}</span>}
    </>
  );
};
